<!-- <div id="alerts-container" class="dnv-alerts justify-content-between align-items-start" [class.d-none]="hideFeedback"
[class.d-flex]="!hideFeedback">
<div class="dnv-alerts-text"><i class="far fa-info-circle"></i>&nbsp;&nbsp;This application
is in Beta. <a class="dnv-alert-link"
href="mailto:gishelp@dnv.org?cc=HeinrichK@dnv.org;itspadsdev@dnv.org&subject=Geotools Feedback; Forward to ITS Dev">Give
us feedback</a> to help improve it. </div>

<button class="float-right btn-disclaimer" (click)="closeFeedback()"><i class="fas fa-times"></i></button>
</div> -->
<div class="headerWrapper" [style.height.px]="headerHeight">
  @if (application$ | async; as application) {
    <div class="navbar fixed-top container-fluid pl-0" #fixedHeader>
      <dnv-mood-canvas class="dnv-mood-canvas"></dnv-mood-canvas>
      <div class="row w-100 mx-0">
        <div class="col-xl-4 col-lg-3 pl-0 col-3">
          <h1 class="navbar-brand" title="Report a Problem">Report a Problem</h1>
        </div>
        <div class="col-xl-4 col-lg-5 col-4 save-map-view d-flex justify-content-center pl-4">
          @if (application.windowInnerWidth > 767) {
            <span>RAP Asset Selection</span>
          }
        </div>
        <div class="col-xl-4 col-lg-4 col-5 d-flex justify-content-end search">
          <div class="search-field mr-2">
            <div class="form-group" [formGroup]="searchForm">
              <input type="text" class="form-control" id="addressSearch" formControlName="addressSearch"
                placeholder="Search for anything" [resultTemplate]="rt" [inputFormatter]="formatter" (blur)="onBlur()"
                (keyup)="onClearSearch($event)" [ngbTypeahead]="search" (selectItem)="onSelectItem($event)">
            </div>
            @if (this.searchForm.get('addressSearch').value) {
              <button type="button" class="clear-search"
                (click)="onClearClicked()"><i class="far fa-times-circle clear-search-icon"></i></button>
              }
            </div>
            <div class="navbar-user" ngbDropdown display="dynamic">
              <button type="button" class="btn btn-link" id="dropdownBasic1" ngbDropdownToggle>{{ userIcon }}</button>
              <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                <button ngbDropdownItem (click)="logout()">Sign out</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  @if (application$ | async; as application) {
    <div class="container-fluid p-0" [style.height.px]="panelHeight"
      [class.props]="applicationState.toolboxStatus === ToolboxStatus.PropertyInfo || applicationState.toolboxStatus === ToolboxStatus.MailMerge || applicationState.toolboxStatus === ToolboxStatus.ServiceConnections">
      <div class="map" [class.mapResize]="mapBorder" [style.height.px]="panelHeight">
        <dnv-map-basemap [mapState]="mapState$ | async" [baseMapState]="(baseMapState$ | async).basemap"
          (onSetBaseMap)="onSelectBasemap($event)" (onToggleBasemaps)="toggleBasemaps()" class="basemap"
          [showSlider]="false" (onOpacityChange)="onOrthoOpacityChange($event)">
        </dnv-map-basemap>
        <dnv-map (mapClick)="onMapClick($event)" (mapMoveChange)="onMoveChange($event)"
          (mapZoomChange)="onZoomChange($event)" (mapUpdate)="onMapUpdate($event)" [mapState]="mapState$ | async"
          [layerState]="layerState$ | async" [textStyle]="textStyle" (editText)="editText($event)"
          (engSearch)="searchEngDrawings($event)" (shapeClick)="onShapeClick($event)" (moveText)="moveText()" #dnvMap>
        </dnv-map>
      </div>
      <div id="interface-container" class="row m-0 interface-container">
        <div class="left-nav-wrapper d-flex">
          <div class="sidebar text-center">
            <button id="btnDrawerLayers" type="button" class="btn btn-link"
              [class.active-btn]="application.status === ApplicationStatus.Layer" (click)="toggleLayer(application.status)"
              title="Layers">
              <i class="far fa-layer-group"></i>
            </button>
            <button id="btnDrawerLegend" type="button" class="btn btn-link" title="Legend"
              [class.active-btn]="application.status === ApplicationStatus.Legend"
              (click)="toggleLegend(application.status)">
              <i class="far fa-list-alt"></i>
            </button>
          </div>
          <div id="layerDiv" class="panel" [class.fade]="application.status !== ApplicationStatus.Layer"
            [style.height.px]="panelHeight">
            <div class="container py-2 px-0">
              <div class="pt-1">
                <div class="d-block title">
                  <button class="btn btn-link float-left w-100 text-start p-0 d-flex" title="Close"
                    (click)="toggleLayer(application.status)">
                    <div class="chevron-wrapper">
                      <i class="fas fa-chevron-left fa-sm"></i>
                    </div>
                    <div class="d-inline-block mt-2 title-text">Layer Control</div>
                  </button>
                </div>
              </div>
              <dnv-layer [layerState]="layerState" [mapState]="mapState$ | async"
                (onSetAvailableLayer)="setAvailableLayer($event)" (onSetActiveLayer)="setActiveLayer($event)"
                (onLayersOrdered)="onLayersOrdered($event)" (onToggleShowFilterPanel)="onToggleShowFilterPanel($event)"
                [showFilterButton]="true" [showHideLayerButton]="true" (onToggleExpand)="onToggleExpand($event)"
                (onHideLayer)="onHideLayer($event)" (onHideFeatureLayer)="onHideFeatureLayer($event)"
                (onClearActiveLayer)="onClearActiveLayer($event)" (onSetOpacity)="onSetOpacity($event)"
                (filterAOI)="onFilterAOI($event)">
              </dnv-layer>
              @if ((layerState$ | async).layers.length === 0) {
                <div class="d-flex justify-content-center">
                  <i class="fas fa-3x fa-spinner fa-spin"></i>
                </div>
              }
            </div>
          </div>
          <div id="layerFilterDiv" class="secondary-panel"
            [class.fade]="!(application.status === ApplicationStatus.Layer && (layerState$ | async).showFilterPanel)"
            [style.height.px]="panelHeight">
            <div class="pt-1 title-wrapper">
              <div class="d-block title" (click)="hideFilterPanel()">
                <button class="btn btn-link float-left" title="Close Layer Filter">
                  <i class="fas fa-chevron-left fa-sm"></i>
                </button>
                <div class="d-inline-block filters-title title-text" title="Layer Filter">Layer Filter</div>
              </div>
            </div>
            <dnv-layer-filter [layerState]="layerState$ | async" [headerHeight]=" headerHeight" [link]="application.link"
              (updateFilter)="onUpdateFilter($event)" (zoomToFeatures)="onZoomToFeatures($event)">
            </dnv-layer-filter>
          </div>
          <div id="legendDiv" class="panel" [style.height.px]="panelHeight"
            [class.fade]="!(application.status === ApplicationStatus.Legend)">
            <div class="container py-2 px-0">
              <div class="pt-1">
                <div class="d-block title">
                  <button class="btn btn-link float-left w-100 text-start p-0 d-flex" title="Close"
                    (click)="toggleLegend(application.status)">
                    <div class="chevron-wrapper">
                      <i class="fas fa-chevron-left fa-sm"></i>
                    </div>
                    <div class="d-inline-block mt-2 title-text">Legend</div>
                  </button>
                </div>
              </div>
              <dnv-legend [legendLayers]="(legendState$ | async).legendLayers" [clickEmit]="true"
                (infoEmitter)="onMetadataClick($event)">
              </dnv-legend>
              <dnv-legend [legendLayers]="(baseMapState$ | async).basemapLegends" (infoEmitter)="onMetadataClick($event)">
              </dnv-legend>
              @if ((legendState$ | async).legendLayers && (legendState$ | async).legendLayers.length === 0 && (baseMapState$ | async).basemapLegends && (baseMapState$ | async).basemapLegends.length === 0) {
                <div
                  class="pt-2 pl-2">
                  There is no legend to display
                </div>
              }
            </div>
          </div>
          <div id="metaDataDiv" class="secondary-panel" [style.height.px]="panelHeight"
            [class.fade]="!(application.status === ApplicationStatus.Legend && (legendState$ | async).showMetadata)">
            <div class="pt-1 title-wrapper">
              <div class="d-block title" (click)="hideMetaData()">
                <button class="btn btn-link float-left" title="Close Layer Filter">
                  <i class="fas fa-chevron-left fa-sm"></i>
                </button>
                <div class="d-inline-block filters-title title-text" title="Layer Filter">Metadata</div>
              </div>
            </div>
            <app-dnv-metadata [legendState]="legendState$ | async"></app-dnv-metadata>
          </div>
          @if ((application$ | async).toolboxStatus !== ToolboxStatus.CCTV) {
            <div>
              @if ((mapState.surroundingFeatureList && mapState.surroundingFeatureList.length > 0) || (mapState.selectedFeature && mapState.selectedFeature.length > 0)) {
                <div id="rightPanel" class="rightPanel"
                  >
                  <dnv-feature-info [mapState]="mapState$ | async" [layerState]="layerState$ | async"
                    [kvSections]="(application$ | async).kvSections" [headerHeight]="headerHeight" [panelHeight]="panelHeight"
                    [validRapFeatureLayer]="validRapFeatureLayer$ | async"
                    [externalFeature]="(application$ | async).externalFeature" [alertHidden]="(application$ | async).alertHidden"
                    (highlightFeature)="highlightFeature($event)" [appSettings]="applicationState.appSettings"
                    (selectFeature)="selectFeature($event)" (closePanel)="closeFeatureInformation()"
                    (emitAssetToRap)="redirectToRap()">
                  </dnv-feature-info>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  }


  <ng-template #rt let-r="result" let-t="term">
    <div>
      <i class="mr-1 {{getClass(r.type)}}"></i> {{ r.name }}
    </div>
  </ng-template>

  <ng-template #engSearch let-r="result" let-t="term">
    {{ r.name }}
  </ng-template>

  <!-- layer info popup-->
  <ng-template #content let-modal>
    <div class="modal-header">
      <h5>Layer Info</h5>
    </div>

    <div class="modal-body" [innerHtml]="layerInfo$ | async">
    </div>

    <div class="modal-footer">

      <button type="button" class="btn" (click)="dismiss()"><i class="fas fa-times"></i>OK</button>

    </div>

  </ng-template>

  <svg class="leaflet-zoom-animated" width="10" height="10" viewBox="-761 -367 10 10"
    style="transform: translate3d(-761px, -367px, 0px);">
    <defs>
      <pattern id="hstripes" x="0" y="0" width="8" height="8" patternUnits="userSpaceOnUse"
        patternContentUnits="userSpaceOnUse">
        <path stroke="#000" stroke-opacity="1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"
        pointer-events="none" d="M0 0.5 H 8"></path>
        <path stroke="#ffffff" stroke-opacity="0" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"
        fill="none" pointer-events="none" d="M0 3 H 8"></path>

      </pattern>
      <pattern id="vstripes" x="0" y="0" width="8" height="8" patternUnits="userSpaceOnUse"
        patternContentUnits="userSpaceOnUse" patternTransform="rotate(90) ">
        <path stroke="#000" stroke-opacity="1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"
        pointer-events="none" d="M0 0.5 H 8"></path>
        <path stroke="#ffffff" stroke-opacity="0" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"
        fill="none" pointer-events="none" d="M0 3 H 8"></path>
      </pattern>
      <pattern id="grid" x="0" y="0" width="11" height="11" patternUnits="userSpaceOnUse"
        patternContentUnits="userSpaceOnUse">
        <rect stroke="#000" stroke-opacity="1" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" fill="none"
        pointer-events="none" x="0" y="0" width="10" height="10"></rect>
      </pattern>
      <pattern id="crosshatch" x="0" y="0" width="11" height="11" patternUnits="userSpaceOnUse"
        patternContentUnits="userSpaceOnUse" patternTransform="rotate(45) ">
        <rect stroke="#000" stroke-opacity="1" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" fill="none"
        pointer-events="none" x="0" y="0" width="10" height="10"></rect>
      </pattern>

    </defs>
  </svg>